export const getWorkspaceConfig = ({ isPageEvent } = {}) => ({
  containerWidth: isPageEvent ? '525px' : '100%',
  contentWidth: isPageEvent
    ? '100%'
    : { xl: '1440px', l: '1024px', m: '768px', s: '100%', _: '100%' },
  horizontalPadding: isPageEvent
    ? '0px'
    : { xl: '32px', l: '32px', m: '24px', _: '16px' },
  isSmallScreen: isPageEvent,
});
